import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { NumberHelper } from "../../../utilities/contracts/number-helper";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { obsolete } from "../../../utilities/decorators/obsolete.decorator";
import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { SelectableInput } from "../selectable-input.model";
import { ConfirmAutocompleteComponent } from "./confirm-autocomplete.component";

export interface IConfirmAutocomplete extends IDynamicInputOptions {
  placeholder?: string;
  searchMinimum?: number;
  options?: any[];
  pageNumber?: number;
  adminValue?: string;
  validationId?: string;
  validationNote?: string;
  dataType?: string;
  autocomplete?: string;
  serverFilter?(query: string, setOptionsFn: (options: SelectableInput[]) => void): void | null;
  filter?(item: SelectableInput, query: string): boolean;
}

// FIXME: @obsolete() // TODO: npm run build //in order to test.
export class ConfirmAutocomplete extends DynamicInput implements IConfirmAutocomplete {
  placeholder: string;
  searchMinimum: number;
  options: any[];
  filter: (item: SelectableInput, query: string) => boolean;
  serverFilter: (query: string, setOptionsFn: (options: SelectableInput[]) => void) => void | null;
  pageNumber: number;
  adminValue: string;
  validationId: string;
  validationNote: string;
  dataType: string;
  autocomplete: string;

  readonly controlType = "text";
  readonly componentType = ConfirmAutocompleteComponent;

  constructor(options: IConfirmAutocomplete = {}) {
    super(options);
    this.placeholder = options.placeholder || "";
    this.searchMinimum = NumberHelper.isGreaterThan(options.searchMinimum, 0) ? options.searchMinimum : 1;
    this.options = options.options || [];
    this.filter = options.filter || null;
    this.serverFilter = options.serverFilter || null;

    if (!ArrayHelper.isAvailable(this.options)) {
      this.value = options.value;
    } else if (typeof this.value === "string" && StringHelper.isAvailable(this.value)) {
      this.value = this.options.find(item => item.value === this.value);
    }

    this.pageNumber = options.pageNumber;
    this.adminValue = options.adminValue;
    this.validationId = options.validationId;
    this.validationNote = options.validationNote;
    this.dataType = options.dataType;
    this.autocomplete = options.autocomplete || "off";
  }


  get hasServerFilter(): boolean {
    return typeof this.serverFilter === "function";
  }
}
